import type { TabNavItem } from '@mercedes-benz/odp-theme-v2';
import { OwnerIcon, RelationsIcon } from '@mercedes-benz/odp-theme-v2';
import { RELATION_HAS_MEMBER } from '@backstage/catalog-model';
import InfoIcon from '@mui/icons-material/Info';
import MergeTypeIcon from '@mui/icons-material/MergeType';
import AccountTreeIcon from '@mui/icons-material/AccountTree';
import { EntityPageLayout } from './EntityPageLayout';
import { CoreDetailsTab } from '../system-details/CoreDetailsTab';
import { RelationsTab } from '../system-details/RelationsTab';
import { RelatedEntitiesTab } from './RelatedEntitiesTab';
import { PullRequestsTab } from './PullRequestsTab';
import { DiagramTab } from './DiagramTab';

const TABS: TabNavItem[] = [
  { id: 'overview', label: 'Overview', icon: InfoIcon },
  { id: 'members', label: 'Members', icon: OwnerIcon },
  { id: 'pull-requests', label: 'Pull Requests', icon: MergeTypeIcon },
  { id: 'diagram', label: 'Diagram', icon: AccountTreeIcon },
  { id: 'relations', label: 'Relations', icon: RelationsIcon },
];

export const GroupEntityPage = () => (
  <EntityPageLayout tabs={TABS}>
    {activeTab => (
      <>
        {activeTab === 'overview' && <CoreDetailsTab />}
        {activeTab === 'members' && (
          <RelatedEntitiesTab
            relationType={RELATION_HAS_MEMBER}
            kindFilter="user"
            title="Members"
          />
        )}
        {activeTab === 'pull-requests' && <PullRequestsTab />}
        {activeTab === 'diagram' && <DiagramTab />}
        {activeTab === 'relations' && <RelationsTab />}
      </>
    )}
  </EntityPageLayout>
);
